import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getOrderApi } from '../../api/orderApi';

export default function OrderSuccess() {
  const { orderId }     = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (orderId) {
      getOrderApi(orderId).then((r) => setOrder(r.data)).catch(() => {});
    }
  }, [orderId]);

  return (
    <div className="page-top" style={S.page}>
      <div style={S.card}>
        <div style={S.topBar} />
        <div style={S.checkIcon}>✓</div>
        <p className="sec-label" style={{ color: 'var(--green)', marginBottom: '8px' }}>Order Confirmed</p>
        <h1 style={S.title}>THANK YOU FOR YOUR ORDER!</h1>
        <p style={S.sub}>Your Bhadralok order has been placed successfully. You'll receive a confirmation email shortly.</p>

        {order && (
          <div style={S.orderBox}>
            <div style={S.orderRow}>
              <span style={S.orderLabel}>Order ID</span>
              <span style={S.orderVal}>#{order.id.slice(0, 8).toUpperCase()}</span>
            </div>
            <div style={S.orderRow}>
              <span style={S.orderLabel}>Total Amount</span>
              <span style={S.orderVal}>₹{order.total_amount}</span>
            </div>
            <div style={S.orderRow}>
              <span style={S.orderLabel}>Status</span>
              <span style={{ ...S.orderVal, color: 'var(--green)', fontWeight: 700 }}>{order.status.toUpperCase()}</span>
            </div>
            <div style={{ ...S.orderRow, border: 'none' }}>
              <span style={S.orderLabel}>Payment</span>
              <span style={S.orderVal}>{(order.payment_method || 'COD').toUpperCase()}</span>
            </div>
          </div>
        )}

        <div style={S.steps}>
          {[
            { icon: '📧', step: 'Confirmation email sent to your inbox' },
            { icon: '⚙️', step: 'Order will be processed within 24 hours' },
            { icon: '🚚', step: 'Shipped in 1–3 business days' },
            { icon: '📦', step: 'Delivered in 5–7 business days' },
          ].map((s) => (
            <div key={s.step} style={S.stepItem}>
              <span style={S.stepIcon}>{s.icon}</span>
              <span style={{ fontSize: '13px', color: '#555' }}>{s.step}</span>
            </div>
          ))}
        </div>

        <div style={S.actions}>
          <Link to="/dashboard" style={S.primaryBtn}>VIEW MY ORDERS →</Link>
          <Link to="/products" style={S.outlineBtn}>CONTINUE SHOPPING</Link>
        </div>

        <p style={S.note}>
          Need help? <Link to="/contact" style={{ color: 'var(--red)', fontWeight: 600 }}>Contact Support</Link> or{' '}
          <Link to="/track-order" style={{ color: 'var(--red)', fontWeight: 600 }}>Track Your Order</Link>
        </p>
      </div>
    </div>
  );
}

const S = {
  page:       { background: 'var(--offwhite)', minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px' },
  card:       { background: '#fff', border: '1px solid var(--border)', maxWidth: '560px', width: '100%', padding: '48px 40px', textAlign: 'center', position: 'relative', overflow: 'hidden' },
  topBar:     { position: 'absolute', top: 0, left: 0, right: 0, height: '4px', background: 'linear-gradient(90deg,var(--red),var(--gold),var(--green))' },
  checkIcon:  { width: '64px', height: '64px', borderRadius: '50%', background: 'var(--green)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-display)', fontSize: '28px', margin: '8px auto 20px' },
  title:      { fontFamily: 'var(--font-display)', fontSize: '24px', letterSpacing: '2px', lineHeight: 1.1, marginBottom: '10px' },
  sub:        { fontSize: '13px', color: '#888', lineHeight: 1.7, marginBottom: '28px', maxWidth: '400px', margin: '0 auto 28px' },
  orderBox:   { background: 'var(--offwhite)', border: '1px solid var(--border)', marginBottom: '24px', textAlign: 'left' },
  orderRow:   { display: 'flex', justifyContent: 'space-between', padding: '11px 16px', borderBottom: '1px solid var(--border)', fontSize: '13px' },
  orderLabel: { color: '#888' },
  orderVal:   { fontWeight: 600 },
  steps:      { display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '28px', textAlign: 'left', padding: '16px', background: 'var(--offwhite)', border: '1px solid var(--border)' },
  stepItem:   { display: 'flex', alignItems: 'center', gap: '12px' },
  stepIcon:   { fontSize: '18px', flexShrink: 0 },
  actions:    { display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '20px', flexWrap: 'wrap' },
  primaryBtn: { background: 'var(--red)', color: '#fff', padding: '12px 24px', fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', textDecoration: 'none', display: 'inline-block' },
  outlineBtn: { background: '#fff', color: 'var(--black)', border: '1.5px solid var(--border)', padding: '12px 24px', fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', textDecoration: 'none', display: 'inline-block' },
  note:       { fontSize: '12px', color: '#aaa' },
};
